const headers = ['label.name', 'countries.iso'];

export default headers;
